module.exports = __webpack_public_path__ + "static/media/slider-thumbnail.5218d649.png";